module.exports = require("react-device-detect");